import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";

const ModalIframePage = ({
  openModal = false,
  children,
  onClosed = () => {},
  triggerType,
  htmlContent = false,
}) => {
  const [iframeHeight, setIframeHeight] = useState(300);

  useEffect(() => {
    const messageListener = (event) => {
      if (event.data?.type && event.data?.type === "closeModal") {
        onClosed(event.data?.isReloadPage || false);
      }
      if (event.data.iframeHeight) {
        setIframeHeight(event.data.iframeHeight);
      }
    };
    window.addEventListener("message", messageListener);
    return () => {
      window.removeEventListener("message", messageListener);
    };
  }, []);

  return (
    <>
      <Modal
        className={`modal-dinamic-table-simple ${triggerType?.type ? `type-${triggerType.type}` : ""}`}
        isOpen={openModal}
        style={
          triggerType?.config?.width
            ? { width: triggerType?.config?.width }
            : {}
        }
        onClosed={onClosed}
      >
        <div>
          <div className="modal-header d-flex align-items-center justify-content-between">
            <h5
              className="modal-title mt-0 font-size-24 font-w-600 text-color-azul1"
              id="myModalLabel"
            >
              {triggerType?.config?.titleModal || "Não mapeado"}
            </h5>
            <button
              type="button"
              onClick={onClosed}
              className="btn border-0 p-0"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i className="fas fa-times font-size-24 text-gray-secundary"></i>
            </button>
          </div>

          {children ? (
            <div className="modal-body">{children}</div>
          ) : <>          
            {triggerType?.type && (
              <div
                className="modal-body"
                style={{ height: `${htmlContent ? 220 : iframeHeight + 30}px` }}
              >
                {!!triggerType && !htmlContent && (
                  <iframe
                    id="embed-view-in-modal"
                    width="100%"
                    height={iframeHeight}
                    src={`${triggerType?.transaction_id}?${triggerType?.params}${!!window?.location.search ? "&" + window?.location.search.replace("?", "") : ""}`}
                    frameborder="0"
                    allowFullScreen="true"
                  ></iframe>
                )}
                {htmlContent && (
                  <iframe
                    id="embed-view-in-modal"
                    title="Visualização do documento"
                    width="100%"
                    height={`${iframeHeight + 200}px`}
                    srcDoc={htmlContent}
                    frameBorder="0"
                    allowFullScreen="true"
                    style={{ display: "block", border: 0 }}
                  ></iframe>
                )}
              </div>
            )}
          </>}

        </div>
      </Modal>
    </>
  );
};

export default ModalIframePage;
